import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Customer } from '../models';
import { CustomerUtils, StringUtils } from '../utils';

@Pipe({
  name: 'customerNameFormatter',
  pure: false,
})
export class CustomerNameFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(customer: Customer, salonPhoneNr?: string): string {
    if (!customer) {
      return '';
    }

    if (CustomerUtils.isAnonymousCustomer(customer, salonPhoneNr)) {
      return this.translateService.instant('pipes.text.walk_in_customer');
    }

    return StringUtils.generateFullName(customer?.name, customer?.surname);
  }
}
